import React, { memo, useMemo } from 'react';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TimelineIcon from '@mui/icons-material/Timeline';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import SchoolIcon from '@mui/icons-material/School';
import IconSvg from '../../../../assets/icons/Icon.svg';

// Icons for each question type
const questionIcons = [
    <TrendingUpIcon key="trend" />,
    <TimelineIcon key="forecast" />,
    <ShowChartIcon key="technical" />,
    <StackedLineChartIcon key="levels" />,
    <SchoolIcon key="guide" />
];

/**
 * StandardQuestions component for displaying contextual questions based on category and instrument
 */
const StandardQuestions = memo(({ onQuestionClick, selectedCategory, selectedInstrument }) => {
    // Question templates per category with short labels
    const questionData = useMemo(() => {
        const displayName = selectedInstrument
            ? selectedInstrument.replace(/_/g, '/').replace('USDT', '/USDT')
            : 'this instrument';

        const questions = [
            {
                label: 'Trend Analysis',
                question: `What is the current trend for ${displayName}?`,
                description: 'Get current market direction and momentum'
            },
            {
                label: 'Price Forecast',
                question: `24h probability forecast for ${displayName}`,
                description: 'AI-powered price predictions'
            },
            {
                label: 'Technical Analysis',
                question: `Explain technical analysis for ${displayName}`,
                description: 'Indicators and chart patterns'
            },
            {
                label: 'Key Levels',
                question: `What are the key support and resistance levels for ${displayName}?`,
                description: 'Critical price points to watch'
            },
            {
                label: 'Trading Guide',
                question: `Beginner guide to trading ${displayName}`,
                description: 'Learn the basics of trading'
            }
        ];

        return questions;
    }, [selectedInstrument]);

    const displayName = selectedInstrument
        ? selectedInstrument.replace(/_/g, '/').replace('USDT', '/USDT')
        : '';

    // Handle both string URL and object exports from SVG imports
    const logoSrc = typeof IconSvg === 'string' ? IconSvg : (IconSvg?.default || IconSvg);

    return (
        <div className="ntb-chat-empty-state">
            <div className="ntb-empty-state-icon">
                <img 
                    src={logoSrc} 
                    alt="NanoTrader Copilot" 
                />
            </div>
            <h2 className="ntb-empty-state-title">
                {displayName ? `Analyze ${displayName}` : 'How can I help you today?'}
            </h2>
            <p className="ntb-empty-state-subtitle">
                Select a topic to get AI-powered trading insights
            </p>
            <div className="ntb-question-cards">
                {questionData.map((item, index) => (
                    <button
                        key={index}
                        className="ntb-question-card"
                        onClick={() => onQuestionClick(item.question)}
                        aria-label={`Ask: ${item.question}`}
                    >
                        <div className="ntb-question-card-icon">
                            {questionIcons[index]}
                        </div>
                        <div className="ntb-question-card-content">
                            <span className="ntb-question-card-label">{item.label}</span>
                            <span className="ntb-question-card-description">{item.description}</span>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
});

StandardQuestions.displayName = 'StandardQuestions';

export default StandardQuestions; 